import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminMicrosSchema } from "./common.js";
/** What answers cost: DataForSEO's `runs.cost_usd`, against the monthly budget. */
export const adminSpendSchema = z.object({
    budgetUsdMicros: adminMicrosSchema,
    monthToDateUsdMicros: adminMicrosSchema,
    projectedUsdMicros: adminMicrosSchema,
    answersMonthToDate: adminCountSchema,
    /** Runs held back because the budget is spent; they wait, they are not dropped. */
    queuedForBudget: adminCountSchema,
    /** This month, day by day. `projected` starts on the last real day. */
    cumulative: z.array(z.object({
        day: adminDaySchema,
        actualUsdMicros: adminMicrosSchema.nullable(),
        projectedUsdMicros: adminMicrosSchema.nullable(),
    })),
    daily: z.array(z.object({
        day: adminDaySchema,
        chatgptUsdMicros: adminMicrosSchema,
        googleAiOverviewUsdMicros: adminMicrosSchema,
        /**
         * Absent when the server does not ask the engine and nothing was spent on
         * it in the range (and always from the Node build), which is not the
         * same as a day it cost nothing: the chart drops the line.
         */
        geminiUsdMicros: adminMicrosSchema.optional(),
        perplexityUsdMicros: adminMicrosSchema.optional(),
        googleAiModeUsdMicros: adminMicrosSchema.optional(),
        copilotUsdMicros: adminMicrosSchema.optional(),
    })),
    workspaces: z.array(z.object({
        workspaceId: z.string(),
        name: z.string(),
        usdMicros: adminMicrosSchema,
        answers: adminCountSchema,
        shareBps: adminCountSchema,
        /** Fourteen days, oldest first, for the row's sparkline. */
        trend: z.array(adminMicrosSchema),
    })),
});
//# sourceMappingURL=spend.js.map